import { styled, theme } from 'ui/theme';

import { Radio } from '../Radio';

export const RadioCard = styled(Radio)`
  border: 1px solid ${theme.colors.build.mediumLight2};
  border-radius: ${theme.borderWidths.medium};
  cursor: pointer;
  margin-bottom: ${theme.space[4]};
  padding: ${theme.space[4]};

  &[data-checked='true'] {
    background-color: ${theme.colors.build.lightDark1};
    border: 1px solid ${theme.colors.action.navigation.standard.static};
  }
`;
